<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <a v-if="getRoleId != '33'" @click="openPage('/frontendSetting/StudioSchedule/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(schedule_image)="data">
            <b-btn @click="showModal('gf' + data.item.id)" size="sm" class="btn-table green"><i class="fas fa-eye mr-5"></i>View</b-btn>
            <b-modal modal-class="modal-custom-image" hide-footer :ref="'gf' + data.item.id" centered>
              <template v-slot:modal-title>
                Schedule {{data.item.studio_name}}
              </template>
			  <img class="w-100 img-fix" :src="parseImg(data.item.schedule_image)">
            </b-modal>
          </template>
          <template v-slot:cell(actions)="data">
            <b-button v-if="getRoleId != '33'" size="sm" @click="editCoach('/frontendSetting/StudioSchedule/edit/' + data.item.id)" class="btn-table primary mr-1">
              <i class="far fa-edit"></i> Edit
            </b-button>
            <b-button v-if="getRoleId != '33'" size="sm" v-on:click="deleteGF(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'frontend_studioschedule',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'studio_name',
          label: 'Studio Name',
          sortable: true
        },
        {
          key: 'schedule_image',
          label: 'Schedule',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      items: [],
      sortType: 'desc',
      sortBy: 'id',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editCoach (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteGF(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/frontend_studioschedule/'.concat(event)).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    parseImg (value) {
      return Auth.apiUrl + 'fitness/v1/img/frontend/studioschedule/' + value
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/frontend_studioschedule?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
